(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["Suggest"] = factory(require("React"), require("ReactDOM"));
	else
		root["Suggest"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_11__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(10);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAsInput = __webpack_require__(6);
	
	var _reactAsInput2 = _interopRequireDefault(_reactAsInput);
	
	var _classnames = __webpack_require__(1);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {};
	
	var Suggest = function (_React$Component) {
	  _inherits(Suggest, _React$Component);
	
	  function Suggest(props) {
	    _classCallCheck(this, Suggest);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Suggest).call(this));
	
	    _this.state = {
	      show: false,
	      value: props.value || props.defaultValue,
	      focus: -1
	    };
	    _this._handleInputChange = _this._handleInputChange.bind(_this);
	    _this._handleSuggestClick = _this._handleSuggestClick.bind(_this);
	    _this._handleFocus = _this._handleFocus.bind(_this);
	    _this._handleDocClick = _this._handleDocClick.bind(_this);
	    _this._handleItemMouseEnter = _this._handleItemMouseEnter.bind(_this);
	    _this._handleItemMouseLeave = _this._handleItemMouseLeave.bind(_this);
	    _this._handleKeyPress = _this._handleKeyPress.bind(_this);
	    return _this;
	  }
	
	  _createClass(Suggest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this._handleDocClick, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.value != null) this.setState({ value: newProps.value });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this._handleDocClick);
	    }
	  }, {
	    key: '_handleInputChange',
	    value: function _handleInputChange(e) {
	      var value = e.target.value;
	      this.setState({ value: value, show: true, focus: -1 });
	      this.props.onChange(value);
	    }
	  }, {
	    key: '_handleSuggestClick',
	    value: function _handleSuggestClick(e) {
	      var index = parseInt(e.target.getAttribute('data-index'));
	      var value = this.props.suggests[index];
	      this.setState({ show: false, value: value });
	      this._focus = false;
	      this.props.onChange(value);
	      this.props.onBlur(value);
	    }
	  }, {
	    key: '_handleDocClick',
	    value: function _handleDocClick(e) {
	      var dom = null;
	      try {
	        dom = _reactDom2.default.findDOMNode(this);
	      } catch (e) {
	        return;
	      }
	      if (e.target === dom.querySelector('.ra-input')) return;
	      if (!this._focus) return;
	      this._focus = false;
	      this.setState({ show: false });
	      this.props.onBlur(this.state.value);
	    }
	  }, {
	    key: '_handleFocus',
	    value: function _handleFocus() {
	      if (this.props.disabled || this.props.readOnly) return;
	      this._focus = true;
	      this.setState({ show: true });
	      this.props.onFocus(this.state.value);
	    }
	  }, {
	    key: '_getSuggests',
	    value: function _getSuggests() {
	      var _this2 = this;
	
	      var focus = this.state.focus;
	      var findex = 0;
	      return this.props.suggests.map(function (suggest, index) {
	        var shouldShow = _this2.props.useFilter ? suggest.indexOf(_this2.state.value) !== -1 : true;
	        var classes = (0, _classnames2.default)({
	          'ra-suggest-item': true,
	          selected: suggest === _this2.state.value,
	          focus: shouldShow && focus === 0
	        });
	        shouldShow && focus--;
	        return shouldShow ? _react2.default.createElement(
	          'li',
	          { className: classes, 'data-findex': findex++, 'data-index': index, key: suggest + '-' + index, onMouseDown: _this2._handleSuggestClick, onMouseEnter: _this2._handleItemMouseEnter, onMouseLeave: _this2._handleItemMouseLeave },
	          suggest
	        ) : null;
	      }).filter(function (s) {
	        return !!s;
	      });
	    }
	  }, {
	    key: '_handleItemMouseEnter',
	    value: function _handleItemMouseEnter(e) {
	      var focus = parseInt(e.target.getAttribute('data-findex'));
	      this.setState({ focus: focus });
	    }
	  }, {
	    key: '_handleItemMouseLeave',
	    value: function _handleItemMouseLeave() {
	      this.setState({ focus: -1 });
	    }
	  }, {
	    key: '_handleKeyPress',
	    value: function _handleKeyPress(e) {
	      var _this3 = this;
	
	      var focus = this.state.focus;
	      var suggests = this.props.suggests.filter(function (suggest) {
	        return _this3.props.useFilter ? suggest.indexOf(_this3.state.value) !== -1 : true;
	      });
	      if (e.which === 38 || e.which === 40) {
	        e.preventDefault();
	        if (focus === -1) focus = e.which === 38 ? suggests.length - 1 : 0;else focus = e.which === 38 ? (focus - 1 + suggests.length) % suggests.length : (focus + 1) % suggests.length;
	        this.setState({ focus: focus });
	      } else if (e.which === 13 && focus !== -1) {
	        this.setState({ show: false, value: suggests[focus], focus: -1 });
	        this._focus = false;
	        this.props.onChange(suggests[focus]);
	        this.props.onBlur(suggests[focus]);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ClassNames;
	
	      var suggests = this._getSuggests();
	      var show = this.state.show && suggests.length > 0;
	      var classes = (0, _classnames2.default)((_ClassNames = {}, _defineProperty(_ClassNames, this.props.className, true), _defineProperty(_ClassNames, 'show', show), _ClassNames));
	      return _react2.default.createElement(
	        'div',
	        { className: classes, style: { width: this.props.width } },
	        _react2.default.createElement(_reactAsInput2.default, _extends({
	          ref: 'input'
	        }, this.props, {
	          className: this.props.inputClassName,
	          onBlur: noop,
	          onChange: this._handleInputChange,
	          onFocus: this._handleFocus,
	          onKeyDown: this._handleKeyPress,
	          placeholder: this.props.placeholder,
	          type: 'text',
	          value: this.state.value
	        })),
	        _react2.default.createElement(
	          'ul',
	          { className: 'ra-suggest-list', ref: 'suggest', style: { maxHeight: this.props.maxHeight } },
	          suggests
	        )
	      );
	    }
	  }]);
	
	  return Suggest;
	}(_react2.default.Component);
	
	Suggest.displayName = 'Suggest';
	Suggest.defaultProps = {
	  defaultValue: '',
	  useFilter: true,
	  disabled: false,
	  name: null,
	  skin: 'default',
	  onChange: noop,
	  onFocus: noop,
	  onBlur: noop,
	  className: 'ra-suggest',
	  inputClassName: 'ra-input',
	  width: 280,
	  maxHeight: 160,
	  suggests: [],
	  placeholder: ''
	};
	Suggest.propTypes = {
	  /**
	   * class name of the suggest input
	   */
	  className: _react2.default.PropTypes.string,
	  /**
	   * default value of the suggest input
	   */
	  defaultValue: _react2.default.PropTypes.string,
	  /**
	   * whether the suggest input is disabled
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * class name of the input
	   */
	  inputClassName: _react2.default.PropTypes.string,
	  /**
	   * max height of the suggest panel
	   */
	  maxHeight: _react2.default.PropTypes.number,
	  /**
	   * name of the suggest input in the form
	   */
	  name: _react2.default.PropTypes.string,
	  /**
	   * callback when blur
	   */
	  onBlur: _react2.default.PropTypes.func,
	  /**
	   * callback when value change
	   */
	  onChange: _react2.default.PropTypes.func,
	  /**
	   * callback when focus
	   */
	  onFocus: _react2.default.PropTypes.func,
	  /**
	   * placeholder of the suggest input
	   */
	  placeholder: _react2.default.PropTypes.string,
	  /**
	   * wheher this suggest input is readonly
	   */
	  readOnly: _react2.default.PropTypes.bool,
	  /**
	   * skin of the suggest input
	   */
	  skin: _react2.default.PropTypes.oneOf(['success', 'error', 'default']),
	  /**
	   * suggset list
	   */
	  suggests: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	  /**
	   * whether suggest is auto filter by current value
	   */
	  useFilter: _react2.default.PropTypes.bool,
	  /**
	   * current value
	   */
	  value: _react2.default.PropTypes.string,
	  /**
	   * width of the suggest input
	   */
	  width: _react2.default.PropTypes.number
	};
	module.exports = Suggest;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(4)) === 'object' && __webpack_require__(4)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function () {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for (var i = 0; i < this.length; i++) {
				var item = this[i];
				if (item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function (modules, mediaQuery) {
			if (typeof modules === "string") modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for (var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if (typeof id === "number") alreadyImportedModules[id] = true;
			}
			for (i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if (mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if (mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 4 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(9);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Input).call(this));
	  }
	
	  _createClass(Input, [{
	    key: 'render',
	    value: function render() {
	      var _ClassNames;
	
	      var _props = this.props;
	      var className = _props.className;
	      var skin = _props.skin;
	      var style = _props.style;
	
	      var props = _objectWithoutProperties(_props, ['className', 'skin', 'style']);
	
	      var classes = (0, _classnames2.default)((_ClassNames = {}, _defineProperty(_ClassNames, className, true), _defineProperty(_ClassNames, skin, true), _defineProperty(_ClassNames, 'disabled', this.props.disabled), _ClassNames));
	      style.width = this.props.width;
	      return _react2.default.createElement('input', _extends({ className: classes, style: style }, props));
	    }
	  }]);
	
	  return Input;
	}(_react2.default.Component);
	
	Input.displayName = 'Input';
	Input.propTypes = {
	  /**
	   * className of the input
	   */
	  className: _react2.default.PropTypes.string,
	  /**
	   * whether the input is disabled
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * skin of the input
	   */
	  skin: _react2.default.PropTypes.oneOf(['success', 'error', 'default']),
	  /**
	   * style of the input
	   */
	  style: _react2.default.PropTypes.object,
	  /**
	   * width of the input
	   */
	  width: _react2.default.PropTypes.number
	};
	Input.defaultProps = {
	  className: 'ra-input',
	  skin: 'default',
	  disabled: false,
	  width: 280,
	  style: {}
	};
	exports.default = Input;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".ra-input{display:inline-block;width:280px;height:40px;padding:10px 16px;font-size:12px;font-family:Microsoft YaHei,tahoma,arial,Hiragino Sans GB,\\\\5B8B\\4F53,sans-serif;line-height:20px;color:#55606e;border:2px solid #fff;border-radius:2px;background-color:#fff;box-sizing:border-box}.ra-input:focus{border:2px solid #24afb2;color:#24afb2;outline:none}.ra-input.success{border:2px solid #26ae90;color:#26ae90}.ra-input.error{border:2px solid #cd4237;color:#cd4237}.ra-input.disabled{border:2px solid #d2d4d8;color:#d2d4d8;cursor:not-allowed}", ""]);
	
	// exports


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".ra-suggest{position:relative;display:inline-block;color:#55606e}.ra-suggest.show .ra-suggest-list{display:block}.ra-suggest .ra-suggest-list{display:none;position:absolute;margin:0;padding:0;list-style:none;background-color:#fff;z-index:9999;width:100%;box-sizing:border-box;overflow-y:auto}.ra-suggest .ra-suggest-list .ra-suggest-item{box-sizing:border-box;height:40px;line-height:20px;padding:10px 16px;font-size:12px;cursor:pointer}.ra-suggest .ra-suggest-list .ra-suggest-item.focus{background-color:#24afb2;color:#fff}", ""]);
	
	// exports


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(7);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./../../postcss-loader/index.js!./../../less-loader/index.js!./index.less", function() {
				var newContent = require("!!./../../css-loader/index.js!./../../postcss-loader/index.js!./../../less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(8);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/postcss-loader/index.js!./../node_modules/less-loader/index.js!./index.less", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/postcss-loader/index.js!./../node_modules/less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** index.js
 **/